import type {Ref} from 'vue';
import {createContext} from '@/shared/createContext';

/** Ein Werkzeug-Slot der Toolbar: freigeschaltet? jetzt benutzbar? öffnen. */
export interface ToolbarTool {
    /** true = Werkzeug freigeschaltet → Toolbar rendert den Button. */
    enabled: Ref<boolean>;
    /** true = die aktuelle Auswahl erlaubt das Werkzeug (sonst Button deaktiviert). */
    canEdit: Ref<boolean>;
    /** Öffnet Dialog/Popover/Sitzung – die UI selbst lebt in `MusicXmlPreview`. */
    open: () => void;
}

/**
 * DER Kontext, über den `MusicXmlPreview` der (Kind-)`ScoreEditToolbar` ihre drei
 * Zusatz-Werkzeuge bereitstellt (ersetzt die früheren drei Einzel-Kontexte Grip/Bass/Lyric:
 * sie hatten dieselbe Form, wurden immer zusammen provided und von genau EINEM Konsumenten
 * injiziert – die Aufteilung sparte keinen einzigen Inject, siehe VUE_RULES Regel 5).
 *
 * - `grip`/`bass`: nur auf der Griffschrift-AUSGABE aktiv – `enabled` spiegelt
 *   `enableGrips`/`enableBassEdit`; der Kontext ist immer provided, der Button erscheint nur
 *   bei `enabled`. So bleibt die Werkzeug-Logik (Dialog/Popover/Anwenden) in `MusicXmlPreview`,
 *   ohne den geteilten {@link ScoreEditContext} (auch der Eingabe-Vorschau) zu belasten.
 * - `lyric`: auf BEIDEN Vorschauen (`enableLyricEdit`); die **Sitzungs-Zustände**
 *   (`activeVerse`, `isLyricActive`, `lyricDraft`) liegen weiterhin im geteilten
 *   `ScoreEditContext`. `blockedReason` erklärt als Tooltip, warum gerade nicht.
 *
 * Injektion mit `null`-Fallback (`injectToolbarExtensions(null)`), damit ein Mount ohne
 * Provider die Werkzeuge einfach weglässt.
 */
export interface ToolbarExtensionsContext {
    grip: ToolbarTool;
    bass: ToolbarTool;
    lyric: ToolbarTool & {
        /** Warum gerade nicht (Tooltip); leer, wenn `canEdit` true ist. */
        blockedReason: Ref<string>;
    };
}

export const [injectToolbarExtensions, provideToolbarExtensions] = createContext<ToolbarExtensionsContext>(
    'MusicXmlPreview', 'ToolbarExtensionsContext',
);
